import { forwardRef } from 'react'
import { motion, HTMLMotionProps } from 'framer-motion'

interface CardProps extends Omit<HTMLMotionProps<'div'>, 'ref'> {
  hover?: boolean
  glow?: 'pink' | 'purple' | 'gold' | 'none'
  padding?: 'none' | 'sm' | 'md' | 'lg'
}

const glowStyles = {
  pink: 'hover:shadow-glow-pink hover:border-primary',
  purple: 'hover:shadow-glow-purple hover:border-secondary',
  gold: 'hover:shadow-glow-gold hover:border-accent',
  none: '',
}

const paddingStyles = {
  none: '',
  sm: 'p-3',
  md: 'p-4',
  lg: 'p-6',
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({
    hover = false,
    glow = 'pink',
    padding = 'md',
    className = '',
    children,
    ...props
  }, ref) => {
    return (
      <motion.div
        ref={ref}
        whileHover={hover ? { y: -2 } : undefined}
        className={`
          bg-bg-card rounded-2xl border border-transparent
          transition-all duration-300
          ${hover ? 'cursor-pointer' : ''}
          ${hover ? glowStyles[glow] : ''}
          ${paddingStyles[padding]}
          ${className}
        `}
        {...props}
      >
        {children}
      </motion.div>
    )
  }
)

Card.displayName = 'Card'
